<template>
  <div class="myCoupon">
    <!-- <div class="nav-bar">
      <van-nav-bar title="优惠券"></van-nav-bar>
    </div> -->
    <van-tabs v-model="active">
      <van-tab title="未使用">
        <div class="coupon-list">
          <!-- 优惠券 -->
          <Coupon v-for=" item in coupons" :key="item.id" :couponData="item"></Coupon>
        </div>
      </van-tab>
      <van-tab title="已过期">
          <div class="coupon-list">
          <!-- 优惠券 -->
          <Coupon v-for=" item in overdueCoupons" :key="item.id" :couponData="item"></Coupon>
        </div>
      </van-tab>
      <van-tab title="已使用">
          <div class="coupon-list">
          <!-- 优惠券 -->
          <Coupon v-for=" item in usedCoupons" :key="item.id" :couponData="item"></Coupon>
        </div>
      </van-tab>
    </van-tabs>
      <van-popup>

      </van-popup>
  </div>

</template>

<script>
  import {mySessionStorage} from '@/utils/storage.js';
  import Coupon from './components/coupon';
  const coupon = [];
  const usedCoupons =[];
  const overdueCoupons =[];
  export default {  
      components: {
    Coupon
  },
    data() {
      return {
        userId:"",
        active:0,
        showList:false,
        chosenCoupon: -1,
        coupons: [],
        usedCoupons:[],
        overdueCoupons:[],
        checkIds:[],
      };
    },
    methods: {
      getMyCoupon() {
        let params = {
          userId: this.userId
        };
        this.$http
          .post(this.$api.myCouponUrl, params)
          .then(res => {
            if (res.code == 200) {
              for(var i=0;i<res.data.length;i++){
                  var status=res.data[i].status;
                  switch(status){
                      case 1:
                          this.coupons.push(res.data[i]);
                          break;
                      case 2:
                          this.usedCoupons.push(res.data[i]);
                          break;
                      case 3:
                          this.overdueCoupons.push(res.data[i]);
                          break;
                  }                  
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }

    },
    created() {
        this.userId = this.$route.query.userId;
    },
    mounted() {
      this.getMyCoupon();
    },
    computed: {
      
    },
    watch: {
     
    }
  };
</script>

<style>
.myCoupon{
    margin: 0;
    background-color: #e5e5e5;
}
.nav-bar{
    height: 40px;
    width: 100%;
    margin: 0;
}
.van-tabs{
    width: 100%;
    height: 100%;
    overflow-y: scroll;
}
.coupon-list{
    width: 100%;
    height: calc(100vh - 44px);
    overflow-y: scroll;
    /* margin-top: 46px; */
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/myCoupon.vue